export enum PerimetryTestType {
  PER_24_2 = "24-2",
  PER_24_2C = "24-2C",
  PER_30_2 = "30-2",
  PER_10_2 = "10-2",
  PER_BINOCULAR = "BINOCULAR",
  PER_BINOCULAR2 = "BINOCULAR2",
  PER_BINOCULAR3 = "BINOCULAR3",
  PER_C_40 = "C-40",
  PER_C_76 = "C-76",
  PER_SUPERIOR36 = "SUPERIOR36",
  PER_SUPERIOR64 = "SUPERIOR64",
  PER_FF_120 = "FF-120",
}
